/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {StatusMsg as Éµb} from './assets/i18n/statusMsg';
export {ResourceDialogComponent as Éµa} from './lib/resource-dialog/resource-dialog.component';